import React from "react";

import {
  MenuList,
  MenuHeader,
  MenuContainer,
  MenuItemContainer
} from "components/navigation/Menu";
import { MenuEntry } from "./styles";
import {
  ICaptionUrl,
  formatCaptionUrlLabel,
  isPreviewedCaptionUrl,
  canPreviewScrapedLink
} from "../captionUrls";

interface IMenu {
  captionUrls: ICaptionUrl[];
  scrapeResultsByUrl: { [url: string]: any };
  attachment: { url?: string; originalUrl?: string };
  onUrlSelected: (url: string) => void;
}

const Menu: React.FC<IMenu> = ({
  captionUrls,
  scrapeResultsByUrl,
  attachment,
  onUrlSelected
}) => (
  <MenuContainer width={280}>
    <MenuHeader>Show preview for</MenuHeader>
    <MenuList>
      {captionUrls.map(captionUrl => {
        const isSelected = isPreviewedCaptionUrl(captionUrl, attachment);
        const isScraped = captionUrl.unshortenedUrl in scrapeResultsByUrl;
        const hasNoPreview =
          isScraped &&
          !canPreviewScrapedLink(scrapeResultsByUrl[captionUrl.unshortenedUrl]);

        return (
          <MenuItemContainer key={captionUrl.unshortenedUrl}>
            <MenuEntry
              $selected={isSelected}
              $disabled={hasNoPreview}
              title={captionUrl.unshortenedUrl}
              onClick={() => {
                if (!hasNoPreview) {
                  onUrlSelected(captionUrl.unshortenedUrl);
                }
              }}
            >
              <span className="label">
                {formatCaptionUrlLabel(captionUrl.unshortenedUrl)}
                {hasNoPreview && (
                  <span className="hint">No preview image</span>
                )}
              </span>
              {isSelected && <i className="icon-check" />}
            </MenuEntry>
          </MenuItemContainer>
        );
      })}
    </MenuList>
  </MenuContainer>
);

export default Menu;
